import { useState } from 'react'
import Header from './components/Header'
import Home from './pages/Home'
import WelcomeScreen from './components/WelcomeScreen'
import { initSettings } from './components/Settings'
import PreviewStatus from './components/PreviewStatus'
import TrialStatus from './components/TrialStatus'

// Apply saved settings (font size, dark mode) on load
initSettings()

export default function App() {
  const [showApp, setShowApp] = useState(!!localStorage.getItem('sk_welcome_seen'))

  return (
    <>
      <PreviewStatus />
      <TrialStatus />
      <WelcomeScreen onEnter={() => setShowApp(true)} />
      {showApp && (
        <div className="app">
          <Header />
          <Home />
          <footer className="app-footer">
            <div className="app-footer-links">
              <a href="https://www.youtube.com/@geezword" target="_blank" rel="noopener noreferrer" title="YouTube">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
              </a>
              <a href="https://www.facebook.com/yemane.russom/" target="_blank" rel="noopener noreferrer" title="Facebook">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="https://geezword.com" target="_blank" rel="noopener noreferrer" className="app-footer-site">
                geezword.com
              </a>
            </div>
          </footer>
        </div>
      )}
    </>
  )
}
